import loader from "../../assets/images/loader.gif";

export default function Loader() {
  return (
    <div className="loader-overlay">
      <div className="loader">
        <img src={loader} alt="Loading" />
      </div>
    </div>
  );
}
